import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ProductsSubcategory } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { useGetAllCategoriesWithProducts } from '@services/useGetAllCategoriesWithProducts';
import { useData } from '@hooks/useData';
import { useParams } from 'react-router';
import { FiltersProvider } from '@context';

export function ProductsSubcategoryPage() {
    const { categoryUuid } = useParams();
    const { allSettings, allCategoriesWithProducts, isLoadingAllCategoriesWithProducts } = useData();
    const { request: requestAllCategoriesWithProducts } = useGetAllCategoriesWithProducts();
    const { t } = useTranslation();

    const parentCategory = allCategoriesWithProducts?.data?.find(
        (item) => item.uuid === categoryUuid || item.children?.some((child) => child.uuid === categoryUuid)
    );
    const selectedCategory = parentCategory?.children?.find((item) => item.uuid === categoryUuid);

    const translations = {
        title: t('products-subcategories-component.metatags.title', {
            category: selectedCategory?.name,
            marketplace: allSettings?.data?.marketplaceName,
        }),
        description: t('products-subcategories-component.metatags.description', {
            category: selectedCategory?.name,
            marketplace: allSettings?.data?.marketplaceName,
        }),
    };

    // call services, if we don't have the information yet
    useEffect(() => {
        !allCategoriesWithProducts && !isLoadingAllCategoriesWithProducts && requestAllCategoriesWithProducts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allCategoriesWithProducts]);

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        image: {
            src: selectedCategory?.image?.src || '',
            type: selectedCategory?.image?.type,
            width: selectedCategory?.image?.width,
            height: selectedCategory?.image?.height,
            alt: selectedCategory?.name || '',
        },
        url: SITE_URLS.productsSubcategory.replace(':categoryUuid', `${categoryUuid}`),
        index: true,
    });

    return (
        <FiltersProvider>
            <ProductsSubcategory
                category={parentCategory?.name || ''}
                subSubcategories={
                    parentCategory?.children?.map((category) => {
                        return {
                            ...category,
                            active: category.uuid === selectedCategory?.uuid,
                            image: category.image?.src,
                        };
                    }) || []
                }
            />
        </FiltersProvider>
    );
}
